// extracted by mini-css-extract-plugin
export var active = "styles-module--active--8fa6a";
export var background = "styles-module--background--bd843";
export var container = "styles-module--container--b6e27";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var matrix = "styles-module--matrix--6f805";
export var matrixContainer = "styles-module--matrixContainer--d832d";
export var mobile = "400px";
export var node = "styles-module--node--76398";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "768px";